import {
  DocumentReference,
  INamedTypeDocument,
  Timestamp,
} from '@principle-theorem/shared';
import { IAppointment } from '../appointment/appointment';
import { IInvoice } from '../invoice/invoice';
import { IPatient } from '../patient/patient';
import { IPractice } from '../practice/practice';
import { IStaffer } from '../staffer/staffer';

export interface ICallEventContext {
  practiceRef: DocumentReference<IPractice>;
  patientRef?: DocumentReference<IPatient>;
  practitionerRef?: DocumentReference<IStaffer>;
  appointmentRef?: DocumentReference<IAppointment>;
  invoiceRef?: DocumentReference<IInvoice>;
  leadRef?: DocumentReference<IPatient>;
}

export interface ICallEvent {
  transcript: string;
  summary?: string;
  context: ICallEventContext;
  affectedResources: INamedTypeDocument[];
  externalId?: string;
  callerPhone?: string;
  callerName?: string;
  /** Call duration in whole seconds. Optional until the public API contract makes it required; used for usage billing. */
  durationSeconds?: number;
  createdAt?: Timestamp;
}

export interface ICallTranscriptTurn {
  speaker: 'agent' | 'caller';
  text: string;
}
